import { api } from "../../api";

const service = process.env.REACT_APP_BACKEND_PROC_URL;

export const proc_api = api(service);

const procurement = () => {
  return {
    CreateProcRequsition: function (data) {
      return proc_api.post(`/ProcurementRequisition/add`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    UpdateProcRequsition: function (data) {
      return proc_api.post(`/ProcurementRequisition/update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetProcRequisitions: function (data) {
      const { pageSize, currentPage, Id, filter, sort, searchText } = data;
      return proc_api.get(
        `/ProcurementRequisition?pageSize=${pageSize || 1}&currentPage=${
          currentPage || 1
        }&id=${
          Id || 0
        }&FilterBy=${filter}&RequisitionType=${sort}&SearchText=${searchText}`,
        data
      );
    },

    GetMyProcRequisitions: function (data) {
      const { pageSize, currentPage, Id, filter, sort, searchText } = data;
      return proc_api.get(
        `/ProcurementRequisition/MyProcurement?pageSize=${
          pageSize || 1
        }&currentPage=${currentPage || 1}&id=${
          Id || 0
        }&FilterBy=${filter}&RequisitionType=${sort}&SearchText=${searchText}`,
        data
      );
    },

    GetProcRequisitionWaivers: function (data) {
      const { pageSize, currentPage, Id, filter, sort, searchText } = data;
      return proc_api.get(
        `/ProcurementRequisitionWaiver?pageSize=${pageSize || 1}&currentPage=${
          currentPage || 1
        }&id=${
          Id || 0
        }&FilterBy=${filter}&RequisitionType=${sort}&SearchText=${searchText}`,
        data
      );
    },

    GetSingleProcRequisitionWaivers: function (data) {
      return proc_api.get(
        `/ProcurementRequisitionWaiver/${data}?id=${data}`,
        data
      );
    },

    ApproveProcRequisitionWaiver: function (data) {
      return proc_api.post(`/ProcurementRequisitionWaiver/approve`, data);
    },

    DeclineProcRequisitionWaiver: function (data) {
      return proc_api.post(`/ProcurementRequisitionWaiver/reject`, data);
    },

    GetProcDelivery: function (data) {
      const { pageSize, currentPage, Id, filter, sort, searchText, all } = data;
      return proc_api.get(
        `/Delivery?pageSize=${pageSize || 1}&currentPage=${
          currentPage || 1
        }&id=${
          Id || 0
        }&FilterBy=${filter}&SortBy=${sort}&ProcurementType=${all}&SearchText=${searchText}`,
        data
      );
    },

    GetSingleProcRequisition: function (data) {
      // const { pageSize, currentPage, TaxIdentificationNumber, id } = data;
      return proc_api.get(`/ProcurementRequisition/${data}?id=${data}`, data);
    },

    ApproveProcRequisition: function (data) {
      return proc_api.post(`/ProcurementRequisition/approve`, data);
    },
    ApproveProcRequisitionBulk: function (data) {
      return proc_api.post(`/ProcurementRequisition/bulk/c`, data);
    },
    DeclineProcRequisition: function (data) {
      return proc_api.post(`/ProcurementRequisition/decline`, data);
    },
    DeclineProcRequisitionBulk: function (data) {
      return proc_api.post(`/ProcurementRequisition/bulk/decline`, data);
    },
    DeleteProcRequisition: function (data) {
      return proc_api.post(`/ProcurementRequisition/delete`, data);
    },
    NotifyProcRequisition: function (data) {
      return proc_api.post(`/ProcurementRequisition/notify`, data);
    },

    CreateProQuotation: function (data) {
      return proc_api.post(`/Quotation/add`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    CreateProQuotationDelivery: function (data) {
      return proc_api.post(`/Delivery/vendorDeliverynote`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    UpdateProQuotation: function (data) {
      return proc_api.post(`/Quotation/update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetProcQuotations: function (data) {
      const {
        pageSize,
        currentPage,
        Id,
        filter,
        sort,
        searchText,
        vendorEmail,
      } = data;

      // Construct query string with only non-empty values
      let queryParams = [
        `pageSize=${pageSize || 1}`,
        `currentPage=${currentPage || 1}`,
        filter ? `FilterBy=${filter}` : "",
        sort ? `SortBy=${sort}` : "",
        searchText ? `SearchText=${encodeURIComponent(searchText)}` : "",
        vendorEmail ? `vendorEmail=${encodeURIComponent(vendorEmail)}` : "",
        Id ? `id=${Id}` : "",
      ]
        .filter(Boolean) // Remove empty values
        .join("&"); // Join with & for the query string

      return proc_api.get(`/Quotation?${queryParams}`, data);
    },

    GetProcQuotationsWorkflow: function (data) {
      const {
        pageSize,
        currentPage,
        Id,
        filter,
        sort,
        searchText,
        vendorEmail,
      } = data;

      // Construct query string with only non-empty values
      let queryParams = [
        `pageSize=${pageSize || 1}`,
        `currentPage=${currentPage || 1}`,
        filter ? `FilterBy=${filter}` : "",
        sort ? `SortBy=${sort}` : "",
        searchText ? `SearchText=${encodeURIComponent(searchText)}` : "",
        vendorEmail ? `vendorEmail=${encodeURIComponent(vendorEmail)}` : "",
        Id ? `id=${Id}` : "",
      ]
        .filter(Boolean) // Remove empty values
        .join("&"); // Join with & for the query string

      return proc_api.get(
        `/Quotation/QuotationRequisition/ApprovalWorkflow?${queryParams}`,
        data
      );
    },
    GetEmployeeProcQuotationsWorkflow: function (data) {
      const {
        pageSize,
        currentPage,
        Id,
        filter,
        sort,
        searchText,
        vendorEmail,
      } = data;

      // Construct query string with only non-empty values
      let queryParams = [
        `pageSize=${pageSize || 1}`,
        `currentPage=${currentPage || 1}`,
        filter ? `FilterBy=${filter}` : "",
        sort ? `SortBy=${sort}` : "",
        searchText ? `SearchText=${encodeURIComponent(searchText)}` : "",
        vendorEmail ? `vendorEmail=${encodeURIComponent(vendorEmail)}` : "",
        Id ? `id=${Id}` : "",
      ]
        .filter(Boolean) // Remove empty values
        .join("&"); // Join with & for the query string

      return proc_api.get(
        `/Quotation/QuotationRequisition/MyApprovalWorkflow?${queryParams}`,
        data
      );
    },

    GetControlQuotations: function (data) {
      const {
        pageSize,
        currentPage,
        Id,
        filter,
        sort,
        searchText,
        vendorEmail,
      } = data;

      // Construct query string with only non-empty values
      let queryParams = [
        `pageSize=${pageSize || 1}`,
        `currentPage=${currentPage || 1}`,
        filter ? `FilterBy=${filter}` : "",
        sort ? `SortBy=${sort}` : "",
        searchText ? `SearchText=${encodeURIComponent(searchText)}` : "",
        vendorEmail ? `vendorEmail=${encodeURIComponent(vendorEmail)}` : "",
        Id ? `id=${Id}` : "",
      ]
        .filter(Boolean) // Remove empty values
        .join("&"); // Join with & for the query string

      return proc_api.get(
        `/Quotation/GetControlQuotation?${queryParams}`,
        data
      );
    },

    GetSingleProcQuotation: function (data) {
      // const { pageSize, currentPage, TaxIdentificationNumber, id } = data;
      return proc_api.get(`/Quotation/${data}`);
    },

    GetPaymentTerms: function (data) {
      return proc_api.get(
        `/Quotation/getPaymentTerms?QuotationId=${data}`,
        data
      );
    },

    ApproveProcQuotation: function (data) {
      return proc_api.post(`/Quotation/approve`, data);
    },
    // Quotation/paymentTerms
    SendQuotationPaymentTerms: function (data) {
      return proc_api.post(`/Quotation/paymentTerms`, data);
    },
    UpdateQuotationPaymentTerms: function (data) {
      return proc_api.post(`/Quotation/updatePaymentTerms`, data);
    },
    DeclineProcQuotation: function (data) {
      return proc_api.post(`/Quotation/decline`, data);
    },

    DeliveredProcQuotation: function (data) {
      return proc_api.post(`/Quotation/delivered`, data);
    },

    CreateVendor: function (data) {
      return proc_api.post(`/Vendor/create`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    UpdateVendor: function (data) {
      return proc_api.post(`/Vendor/update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    ApproveVendor: function (data) {
      return proc_api.post(`/Vendor/approve`, data);
    },
    DeclineVendor: function (data) {
      return proc_api.post(`/Vendor/decline`, data);
    },
    GetBeneficiaries: function (data) {
      return proc_api.get(`/BeneficiaryNames`, data);
    },
    GetDepartments: function (data) {
      return proc_api.get(`/Department`, data);
    },
    GetVendorsSingle: function (data) {
      // const { pageSize, currentPage, TaxIdentificationNumber, id } = data;
      return proc_api.get(`/Vendor/${data}?id=${data}`, data);
    },
    CreateVendorAsset: function (data) {
      return proc_api.post(`/Vendor/create/asset`, data);
    },
    GetAllVendorsAssets: function (data) {
      return proc_api.get(`/Vendor/allAssets`, data);
    },
    AddStock_Vendor: function (data) {
      return proc_api.post(`/Vendor/stock/add`, data);
    },
    GetProcRequisitionDashboard: function () {
      return proc_api.get("/ProcurementRequisition/dashboard");
    },
  };
};

const memo = () => {
  return {
    CreateMemoRequisition: function (data) {
      return proc_api.post(`/Memo/CreateMemo`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    UpdateMemoRequisition: function (data) {
      return proc_api.post(`/Memo/update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetMemoRequisitions: function (data) {
      const { pageSize, currentPage, approvalStatus, searchText } = data;
      return proc_api.get(
        `/Memo/Memo/ApprovalWorkflow?PageSize=${pageSize || 1}&PageNumber=${
          currentPage || 1
        }&ApprovalStatus=${approvalStatus}&Search=${searchText}`,
        data
      );
    },

    GetEmployeeMemoRequisitions: function (data) {
      const { pageSize, currentPage, approvalStatus, sort, searchText } = data;
      return proc_api.get(
        `/Memo/GetMyMemo?PageSize=${pageSize || 1}&PageNumber=${
          currentPage || 1
        }&ApprovalStatus=${approvalStatus}&RequisitionType=${sort}&Search=${searchText}`,
        data
      );
    },

    GetSingleMemoRequisition: function (data) {
      // const { pageSize, currentPage, TaxIdentificationNumber, id } = data;
      return proc_api.get(`/Memo/GetById/${data}?id=${data}`, data);
    },

    ApproveMemoRequisition: function (data) {
      return proc_api.post(`/Memo/Approve`, data);
    },

    DeclineMemoRequisition: function (data) {
      return proc_api.post(`/Memo/Decline`, data);
    },

    EscalateMemoRequisition: function (data) {
      return proc_api.post(`/Memo/Escalate`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
  };
};

export const ProcurementServices = {
  procurement: procurement,
  memo,
};
